import { createAction } from 'redux-actions';
import * as actions from './actions';

export const fetchBookingsListRequest = createAction(actions.FETCH_BOOKINGS_LIST_REQUEST);
export const fetchBookingsListSuccess = createAction(actions.FETCH_BOOKINGS_LIST_SUCCESS);
export const fetchBookingsListFailure = createAction(actions.FETCH_BOOKINGS_LIST_FAILURE);
